import React, { useEffect, useState } from 'react';
import ArticlesCardView from "./articles-card.view";
import server from "../../../server";
import "../../../styles/component/dashboard/dashboard-cards.scss";

const ArticlesCard = () => {

    const [data, setData] = useState<any>([]);
    const [isLoading, setIsLoading] = useState<boolean>(false);

    useEffect(() => {
        fetchArticles();
    }, [])


    function mapRes(res: any) {
        return res.map((item: any) => ({
            title: item.title,
            description: item.description,
            url: item.url,
            profileImageURL: item.user.profile_image_90,
            publishedDate: item.readable_publish_date,
            author: item.user.name,
            coverImage:item.cover_image
        }));
    }

    async function fetchArticles() {
        setIsLoading(true);
        try {
            const res = await server.utils.articles.get();
            const formattedRes = mapRes(res);
            setData(formattedRes);
        } catch (e) {
            console.log(e, 'error caught while fetching articles')
        } finally {
            setIsLoading(false);
        }

    }


    return (
        <ArticlesCardView
            data={data}
            isLoading={isLoading}
        />
    )


}

export default ArticlesCard;
